import { render, staticRenderFns } from "./AdMediaApi.vue?vue&type=template&id=2e3b8796&scoped=true&"
import script from "./AdMediaApi.vue?vue&type=script&lang=js&"
export * from "./AdMediaApi.vue?vue&type=script&lang=js&"
import style0 from "./AdMediaApi.vue?vue&type=style&index=0&id=2e3b8796&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3b8796",
  null
  
)

export default component.exports